import { render, staticRenderFns } from "./RightTabBar.vue?vue&type=template&id=4404bb92&scoped=true"
import script from "./RightTabBar.vue?vue&type=script&lang=js"
export * from "./RightTabBar.vue?vue&type=script&lang=js"
import style0 from "./RightTabBar.vue?vue&type=style&index=0&id=4404bb92&prod&lang=scss&scoped=true"
import style1 from "./RightTabBar.vue?vue&type=style&index=1&id=4404bb92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404bb92",
  null
  
)

export default component.exports